import { Text, Stack, Link } from 'basis';
import { LayoutForm, LayoutPage } from 'components';
import { ApiAchConsentEndpointError } from 'hooks/useGreenId';

export const AchError = ({ error }: { error?: string | null }) => {
  return (
    <LayoutPage step="update" hideProgressStepper>
      <LayoutForm>
        <Stack gap="8">
          <Text as="h1" textStyle="heading5" textStyle-md="heading4">
            Sorry, we encountered an error
          </Text>
          <Text>
            Unfortunately, we are unable to verify your identity. {error !== ApiAchConsentEndpointError && <>Please contact support at <Link href="mailto:customer.support@gbgplc.com">customer.support@gbgplc.com</Link> for further help.</>}
          </Text>
        </Stack>
      </LayoutForm>
    </LayoutPage>
  );
};
